{
  "wallboard": {
    "instances_count": "没有实例 | {count} 个实例 | {count} 个实例",
    "label": "应用墙"
  }
}
